// Palette
import palette from '../palette';

export default {
  root: {
    backgroundColor: palette.background.default,
    color: '#425A70'
  },
  clickable: {
    '&:hover, &:focus, &:active': {
      backgroundColor: '#EDF0F2'
    }
  },
  deletable: {
    '&:focus': {
      backgroundColor: palette.background.default
    }
  },
  outlined: {
    '&:hover': {
      backgroundColor: palette.background.default
    }
  }
};
